import { ConcatTransformation } from '@ardoq/api-types';
import { EditorSectionProps } from './types';
import { SelectOption, SortableMultiselect } from '@ardoq/select';
import { Field, TextInput } from '@ardoq/forms';
import { AutocompleteFieldSuggestion } from './types';
import { isTruthy } from '@ardoq/common-helpers';
import { DEFAULT_ARDOQ_I18NLOCALE, I18nLocale, t } from '@ardoq/i18n';

type ConcatDetailsSectionProps = EditorSectionProps<ConcatTransformation> & {
  i18nLocale?: I18nLocale;
};

export const ConcatDetailsSection = ({
  value,
  onValueChange,
  reactiveFieldOptions,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: ConcatDetailsSectionProps) => {
  const selectedOptions = value.config.additionalFields
    .map(field =>
      reactiveFieldOptions?.find(option => option.value.name === field)
    )
    .filter(isTruthy);

  const handleSeparatorChange = (joinStr: string) =>
    onValueChange({ ...value, config: { ...value.config, joinStr } });

  const handleFieldsChange = (
    fields: SelectOption<AutocompleteFieldSuggestion>[] | null
  ) =>
    onValueChange({
      ...value,
      config: {
        ...value.config,
        additionalFields: fields?.map(field => field.value.name) || [],
      },
    });

  return (
    <>
      <Field
        label={t(
          i18nLocale,
          'scopeData:calculatedFields.concat.fieldsLabel',
          'Fields'
        )}
      >
        <SortableMultiselect
          placeholder={t(
            i18nLocale,
            'scopeData:calculatedFields.concat.fieldsPlaceholder',
            'Select fields to concatenate'
          )}
          options={reactiveFieldOptions || []}
          value={selectedOptions}
          onChange={handleFieldsChange}
          i18nLocale={i18nLocale}
        />
      </Field>
      <Field
        label={t(
          i18nLocale,
          'scopeData:calculatedFields.concat.separatorLabel',
          'Separator'
        )}
      >
        <TextInput
          value={value.config.joinStr}
          onValueChange={handleSeparatorChange}
        />
      </Field>
    </>
  );
};
